<template>
    <transition name="transition-punch">
        <div class="coupon-activity-container" v-show="visible">
            <div class="coupon-wrapper">
                <img src="../assets/imgs/img_coupon_activity_back.svg" class="back" alt="">

                <div class="coupon-area">
                    <p class="min-title">你有一个</p>
                    <p class="max-title">加佣大礼包</p>
                    <dl class="activity-list">
                        <dd class="activity-item" 
                            v-for="(item,index) in activityList" :key="index"
                            :class="{multi: item.num!=='1'}">
                            <div class="percentage">{{ item.extra_distribution_proportion | formatNum }}</div>
                            <div class="content">
                                <p class="title">{{item.name}}x{{item.num}}</p>
                                <p class="desc">{{item.desc}}</p>
                            </div>
                        </dd>
                    </dl>
                </div>
                <a href="javascript:;" class="btn" @click="handleGetCoupon"><i class="iconfont icon-gitf"></i>点击领取</a>
                <a href="javascript:;" class="close" @click="handleClose"><i class="iconfont icon-close"></i></a>
            </div>
        </div>
    </transition>
</template>

<script>
    import { getReceiveActivityCoilingList, userReceiveActivityCoiling } from '@/api/distribution'

    export default {
        data() {
            return {
                visible: false,
                activityId: null,
                activityList: []
            }
        },
        props: {
            isUserPage: {
                type: Boolean,
                default: false
            }
        },
        filters: {
            formatNum(val) {
                return `${val * 100}`;
            }
        },
        computed: {
            isfirstTimeGetCoupons() {
                return this.$store.state.isfirstTimeGetCoupons;
            }
        },
        methods: {
            loadData() {
                if (!this.isfirstTimeGetCoupons && !this.isUserPage) return;

                getReceiveActivityCoilingList().then(res => {
                    if (res.data && res.data.activityList.length > 0) {
                        this.activityList = res.data.activityList;
                        this.activityId = res.data.id;
                        this.visible = true;
                    } else {
                        this.visible = false;
                        if(this.isUserPage){
                            this.$router.push({
                                name: 'couponList'
                            })
                        }
                    }
                })
            },
            //领取券
            handleGetCoupon() {

                if(!this.activityId) return;

                const param = {
                    activityId: this.activityId
                };
                userReceiveActivityCoiling(param).then((res) => {
                    if (res.data === 1) {
                        this.$toast.succeed('加佣券领取成功！')
                    }else {
                        this.$toast.failed('加佣券领取失败！')
                    }
                });
            },
            //关闭弹窗
            handleClose() {
                this.show = false;

                if(!this.isUserPage){
                    this.$store.commit('changefirstTimeGetCoupons', false);
                }
            }
        },
        mounted() {

        }
    }
</script>

<style lang="scss">
    .coupon-activity-container{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 10000;
        background: rgba(0,0,0,.7);
        padding: 30px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        
        .back{
            width: 4.8rem;
            display: block;
        }
        .coupon-wrapper{
            position: relative;
        }
        .coupon-area{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            padding: 40px 20px 60px 20px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .min-title{
            font-size: 28px;
            font-weight: bold;
            color: #fff;
            margin-top: .2rem;
        }
        .max-title{
            font-size: 36px;
            font-weight: bold;
            color: #fff;
            margin-top: 5px;
        }
        .activity-item{
            width: 3.68rem;
            height: 1.12rem;
            margin-top: 30px;
            display: flex;
            align-items: center;
            background: url('../assets/imgs/img_coupon_activity_card1.svg') no-repeat;
            background-size: 3.6rem 1.12rem;
            
            &.multi{
                padding-top: .08rem;
                background: url('../assets/imgs/img_coupon_activity_card2.svg') no-repeat;
                background-size: 3.68rem 1.2rem;
            }
            .percentage{
                position: relative;
                font-size: .28rem;
                color: #FF7733;
                width: 1rem;
                text-align: center;

                &:after{
                    content: '%';
                    display: inline-block;
                    position: relative;
                    bottom: 0;
                    font-size: .2rem;
                    color: #FF7733;
                }
            }
            .content{
                width: 0;
                flex: 1;
                padding-right: .2rem;
            }
            .title{
                font-size: .24rem;
                color: #595959;
            }
            .desc{
                font-size: .16rem;
                color: #8C8C8C;
                margin-top: 5px;
            }
        }
        .btn{
            width: 3.2rem;
            height: .84rem;
            background-color: #fff;
            border-bottom: 2px solid #F54F4F;
            border-radius: .84rem;
            color: #F54F4F;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: .32rem;
            margin: 0 auto;
            position: relative;
            margin-top: -.5rem;
            animation: move 1s infinite alternate;

            .iconfont{
                font-size: .38rem;
                margin-right: 5px;
            }
        }
        .close{
            width: .48rem;
            height: .48rem;
            margin: 0 auto;
            margin-top: .55rem;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            border: 1px solid #fff;
            border-radius: 50%;

            .iconfont{
                font-size: .3rem;
            }
        }
    }
    @keyframes move {
        from {
            transform: scale(1)
        }
        to {
            transform: scale(1.05)
        }
    }
</style>